<template>
  <div v-if="$store.getters.user != null" class="container">
    <div class="row">
      <div class="col">
        <h4 class="my-2">Subjects</h4>
      </div>
    </div>
    <div
      class="row text-left"
      v-for="organization in organizations
        .filter(o => o.Organization_Type_Id == 3 || o.Organization_Type_Id == 4)
        .slice()
        .sort($orderByName)"
      :key="organization.Organization_Id"
    >
      <div class="col">
        <div class="row underlined">
          <div class="col">
            <h4 class="my-2">{{ organization.Name }}</h4>
          </div>
        </div>
        <div
          v-for="schoolGroup in organizations
            .filter(
              o =>
                (o.Organization_Type_Id == 6 ||  o.Organization_Type_Id == 7) &&
                o.Parent_Organization_Id == organization.Organization_Id
            )
            .slice()
            .sort($orderByName)"
          :key="schoolGroup.Organization_Id"
        >
          <div
            class="row mb-4"
            v-if="
              schoolGroup.Subjects.length > 0 ||
                $canManageOrganization(
                  $store.getters.user.Permissions,
                  organization.Organization_Id
                ) ||
                $canManageOrganization(
                  $store.getters.user.Permissions,
                  schoolGroup.Organization_Id
                )
            "
          >
            <div class="col">
              <div class="row">
                <div class="col">
                  <h5 class="mb-4 mt-2">{{ schoolGroup.Name }}</h5>
                </div>
                <div class="col-auto">
                  <button
                    v-if="canAddSubject(schoolGroup)"
                    class="btn btn-sm btn-primary"
                    v-on:click="addSubject(schoolGroup)"
                  >
                    New Subject
                  </button>
                </div>
              </div>
              <SubjectRow
                v-for="subject in schoolGroup.Subjects.slice().sort(
                  $orderByTitle
                )"
                :key="subject.Subject_Id"
                v-bind:Id="'subject' + subject.Subject_Id"
                v-bind:Subject="subject"
                v-bind:Students="students"
                @edit-subject="editSubject(subject, schoolGroup)"
                @manage-students="manageStudents(subject, schoolGroup)"
                @new-unit="
                  createNewUnit(subject, schoolGroup.Parent_Organization_Id)
                "
                @add-unit-score="addUnitScore"
                @manage-unit="manageUnit"
              />
            </div>
          </div>
        </div>
        <div
          v-if="
            !organizations.some(
              o =>
                (o.Organization_Type_Id == 6 ||  o.Organization_Type_Id == 7) &&
                o.Parent_Organization_Id == organization.Organization_Id
            )
          "
        >
          <p class="my-4">
            You have no groups. Go to your organization or account
            settings to create a group in order to create/manage subjects.
          </p>
        </div>
      </div>
    </div>
    <AddEddSubjectModal
      v-bind:Organization="selectedOrganization"
      v-bind:Students="organizationStudents"
      v-bind:Subject="subjectToEdit"
      @added-subject="subjectAdded"
      @edited-subject="subjectEdited"
      @subject-archived="subjectArchived"
    />
    <ManageSubjectStudentsModal
      v-bind:Subject="managingSubject"
      v-bind:AllStudents="organizationStudents"
      @updated-subject-students="subjectStudentsUpdated"
    />
    <AddEditUnitModal
      v-bind:Subject="unitSubject"
      v-bind:ScoreTemplates="scoreTemplates"
      v-bind:Students="unitStudents"
      v-bind:SchoolOrganizationId="schoolOrganizationId"
      @added-unit="unitAdded"
    />
    <AddUnitScoreModal
      v-bind:Students="scoreStudents"
      v-bind:Unit="scoreUnit"
      @added-scores="scoresAdded"
    />
    <ManageUnitModal
      v-bind:Unit="unitToManage"
      v-bind:ScoreTemplates="scoreTemplates"
      v-bind:Students="organizationStudents"
      v-bind:Subject="manageUnitSubject"
      @edited-unit="unitEdited"
      @student-unit-archived="studentUnitArchived"
      @unit-archived="unitArchived"
    />
  </div>
</template>

<script>
import $ from "jquery";
import AddEddSubjectModal from "@/modals/Subject/AddEditSubjectModal.vue";
import ManageSubjectStudentsModal from "@/modals/Subject/ManageSubjectStudentsModal.vue";
import SubjectRow from "@/components/Subjects/SubjectRow.vue";
import AddEditUnitModal from "@/modals/Unit/AddEditUnitModal.vue";
import AddUnitScoreModal from "@/modals/Subject/AddUnitScoreModal.vue";
import ManageUnitModal from "@/modals/Unit/ManageUnitModal.vue";

export default {
  name: "Subjects",
  components: {
    AddEddSubjectModal,
    ManageSubjectStudentsModal,
    SubjectRow,
    AddEditUnitModal,
    AddUnitScoreModal,
    ManageUnitModal
  },
  watch: {
    "$store.getters.user": async function() {
      this.loadSubjects();
    }
  },
  data() {
    return {
      organizations: [],
      students: [],
      selectedOrganization: null,
      subjectToEdit: null,
      organizationStudents: [],
      managingSubject: null,
      unitSubject: null,
      scoreTemplates: [],
      subjectStudents: [],
      unitStudents: [],
      scoreStudents: [],
      scoreUnit: null,
      schoolOrganizationId: null,
      unitToManage: null,
      manageUnitSubject: null
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.loadSubjects();
  },
  methods: {
    async loadSubjects(scrollToSubject = -1) {
      var view = this;
      if (view.$store.getters.user != null) {
        view.organizations = [];
        view.students = [];
        view.students = await view.$getMySubjectStudents();
        view.scoreTemplates = (await this.$getMyScoreTemplates()).filter(
          s => s.Score_Template_Type_Id == 1
        );
        view.organizations = await view.$getMySubjectOrganizations();
        if (scrollToSubject != -1) {
          this.scrollToSubject(scrollToSubject);
        }
        this.$store.commit("updateLoading", false);
      }
    },
    canAddSubject(organization) {
      return this.$canManageOrganization(
        this.$store.getters.user.Permissions,
        organization.Organization_Id
      );
    },
    addSubject(organization) {
      this.selectedOrganization = organization;
      this.organizationStudents = this.students.filter(s =>
        s.Organizations.some(
          o => o.Organization_Id == organization.Organization_Id
        )
      );
      this.subjectToEdit = null;
      $("#addEditSubjectModal").modal("show");
    },
    editSubject(subject, organization) {
      this.selectedOrganization = organization;
      this.organizationStudents = this.students.filter(s =>
        s.Organizations.some(
          o => o.Organization_Id == organization.Organization_Id
        )
      );
      this.subjectToEdit = subject;
      $("#addEditSubjectModal").modal("show");
    },
    async subjectAdded(newSubject) {
      await this.loadSubjects(newSubject.Subject_Id);
    },
    async subjectEdited(editedSubject) {
      await this.loadSubjects(editedSubject.Subject_Id);
      this.selectedOrganization = null;
      this.subjectToEdit = null;
    },
    manageStudents(subject) {
      this.organizationStudents = this.getOrganizationStudents(subject);
      this.managingSubject = subject;
      $("#manageSubjectStudentsModal").modal("show");
    },
    async subjectStudentsUpdated(subjectId) {
      await this.loadSubjects(subjectId);
    },
    getOrganizationStudents(subject) {
      return this.students.filter(s =>
        s.Organizations.some(o => o.Organization_Id == subject.Organization_Id)
      );
    },
    createNewUnit(subject, schoolOrganizationId) {
      this.unitStudents = this.getOrganizationStudents(subject);
      this.unitSubject = subject;
      this.schoolOrganizationId = schoolOrganizationId;
      $("#addEditUnitModal").modal("show");
    },
    async unitAdded(subjectId) {
      await this.loadSubjects(subjectId);
    },
    addUnitScore(unit, subject) {
      var possibleStudents = this.getOrganizationStudents(subject);
      var unitStudents = [];
      possibleStudents.forEach(student => {
        if (student.Units.map(u => u.Unit_Id).includes(unit.Unit_Id)) {
          unitStudents.push(student);
        }
      });
      this.scoreStudents = unitStudents;
      this.scoreUnit = unit;
      this.scoreUnit.Score_Template = this.scoreTemplates.find(
        t => t.Score_Template_Id == unit.Score_Template_Id
      );
      $("#addUnitScoreModal").modal("show");
    },
    scoresAdded() {
      this.$showSnackbar("The score(s) have been added.", false);
    },
    manageUnit(unit, subject) {
      this.organizationStudents = this.getOrganizationStudents(subject);
      this.unitToManage = unit;
      this.manageUnitSubject = subject;
      $("#manageUnitModal").modal("show");
    },
    async unitEdited(editedUnit) {
      this.unitToManage = null;
      var organizationIndex = this.organizations.findIndex(o =>
        o.Subjects.some(s =>
          s.Units.map(u => u.Unit_Id).includes(editedUnit.Unit_Id)
        )
      );
      var subjectIndex = this.organizations[
        organizationIndex
      ].Subjects.findIndex(s =>
        s.Units.map(u => u.Unit_Id).includes(editedUnit.Unit_Id)
      );
      var unitIndex = this.organizations[organizationIndex].Subjects[
        subjectIndex
      ].Units.findIndex(u => u.Unit_Id == editedUnit.Unit_Id);

      this.$set(
        this.organizations[organizationIndex].Subjects[subjectIndex].Units,
        unitIndex,
        editedUnit
      );
      this.unitToManage = editedUnit;
    },
    scrollToSubject(subjectId) {
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#subject" + subjectId).length > 0) {
          var elmnt = document.getElementById("subject" + subjectId);
          elmnt.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    },
    studentUnitArchived(studentId, unit) {
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == studentId
      );
      this.students[studentIndex].Units = this.students[
        studentIndex
      ].Units.filter(u => u.Unit_Id != unit.Unit_Id);
    },
    subjectArchived(subject) {
      var organizationIndex = this.organizations.findIndex(o =>
        o.Subjects.some(s => s.Subject_Id == subject.Subject_Id)
      );
      this.subjectToEdit = null;
      this.organizations[organizationIndex].Subjects = this.organizations[
        organizationIndex
      ].Subjects.filter(s => s.Subject_Id != subject.Subject_Id);
    },
    unitArchived(unit) {
      var organizationIndex = this.organizations.findIndex(o =>
        o.Subjects.some(s => s.Units.map(u => u.Unit_Id).includes(unit.Unit_Id))
      );
      var subjectIndex = this.organizations[
        organizationIndex
      ].Subjects.findIndex(s =>
        s.Units.map(u => u.Unit_Id).includes(unit.Unit_Id)
      );
      this.unitToManage = null;
      this.organizations[organizationIndex].Subjects[
        subjectIndex
      ].Units = this.organizations[organizationIndex].Subjects[
        subjectIndex
      ].Units.filter(u => u.Unit_Id != unit.Unit_Id);
    }
  }
};
</script>
